import { takeLast, propOr } from 'ramda';
import { createSelector } from 'reselect';

import { selectors } from '@ezugi/bootstrap';

import {
  MAX_COLUMNS_COUNT,
  MAX_ROWS_COUNT,
  ROADMAP_CELL_TYPE,
} from '../../components/Roadmap/constants';
import {
  generateColumnMatrix,
  isTriple,
  isBig,
  isSmall,
  isEven,
} from '../../components/Roadmap/utils';

const { gameSelector } = selectors;

const historySelector = createSelector(gameSelector, propOr([], 'history'));
export const roadmapSelector = createSelector(historySelector, (history) => {
  const entries = takeLast(MAX_COLUMNS_COUNT * MAX_ROWS_COUNT, history).map(
    ({ DiceOne, DiceTwo, DiceThree, RoundId }) => {
      const result = [ DiceOne, DiceTwo, DiceThree ];
      const type = (() => {
        if (isTriple(result)) return ROADMAP_CELL_TYPE.TRIPLE;
        if (isBig(result)) return ROADMAP_CELL_TYPE.BIG;
        if (isSmall(result)) return ROADMAP_CELL_TYPE.SMALL;
        return '';
      })();
      return {
        type,
        roundId: RoundId,
      };
    }
  );

  return generateColumnMatrix(entries);
});

export const roadmapSelectorOddAndEven = createSelector(historySelector, (history) => {
  const entries = takeLast(MAX_COLUMNS_COUNT * MAX_ROWS_COUNT, history).map(
    ({ DiceOne, DiceTwo, DiceThree, RoundId }) => {
      const result = [ DiceOne, DiceTwo, DiceThree ];
      const type = (() => {
        if (isTriple(result)) return ROADMAP_CELL_TYPE.TRIPLE;
        if (isEven(result)) return ROADMAP_CELL_TYPE.EVEN;
        return ROADMAP_CELL_TYPE.ODD;
      })();
      return {
        roundId: RoundId,
        type,
      };
    }
  );

  return generateColumnMatrix(entries);
});
